// No ES6 exports, since we're using this outside just the client code
module.exports = {
  parseApplicationId: '5VTf18HFnpVW7hT6JiaMh3Ztys9HaZvPQcIMUiWP',
  parseJavascriptKey: '2xZinoYaXp1Ly7l2rGHrpvXndlv1YXR6gngsY4PJ',
  publicPath: '/dashboard/',
  basename: '/dashboard',
  appMountId: 'main'
}



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/config.js